import { useIntl } from "react-intl"
import type { AreaResult } from "@/types/quizzes"

/** Score per content area with a bar for each, for quiz and exam results. */
export function AreaBreakdown({ areas }: { areas: AreaResult[] }) {
  const intl = useIntl()
  return (
    <ul className="mt-4 divide-y divide-hairline overflow-hidden rounded-xl border border-hairline bg-page p-0">
      {areas.map((area) => {
        const percent = Math.round((area.correct / area.total) * 100)
        return (
          <li key={area.name} className="list-none px-4 py-3">
            <div className="flex items-baseline justify-between gap-4">
              <span className="min-w-0 text-sm text-ink-display">{area.name}</span>
              <span className="shrink-0 text-sm text-ink-muted">
                {area.correct} / {area.total} · {percent}%
              </span>
            </div>
            <div
              className="mt-2 h-1.5 overflow-hidden rounded-full bg-surface"
              role="meter"
              aria-label={intl.formatMessage({ id: "quizzes.area_score" }, { name: area.name })}
              aria-valuemin={0}
              aria-valuemax={100}
              aria-valuenow={percent}
            >
              <div className="h-full bg-accent" style={{ width: `${percent}%` }} />
            </div>
          </li>
        )
      })}
    </ul>
  )
}
